import { faStar as faStarSolid } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import { Numbers } from '@fff-web/fff-utilities';
import * as styles from './StarReviewGraph.module.scss';

type RatingRowProps = {
  rDistributionNumber: number;
  totalReviews: number;
  totalStars: number;
  productId: number;
};

const RatingRow = ({
  rDistributionNumber,
  totalReviews,
  totalStars,
  productId,
}: RatingRowProps) => {
  const progress = totalReviews > 0 ? ((totalStars * 100) / totalReviews).toFixed(1) : '0';
  return (
    <div
      className={styles.ratingRow}
      data-testid={`rating-row-${rDistributionNumber}`}
      key={`${productId}-${rDistributionNumber}`}
    >
      <div className={styles.ratingInfo}>
        <span>{rDistributionNumber}</span> <FontAwesomeIcon icon={faStarSolid} />
      </div>
      <div className={styles.ratingProgress}>
        <div
          className={styles.ratingProgressBar}
          role="progressbar"
          style={{
            width: `${progress}%`,
          }}
          aria-valuenow={parseInt(progress, 10)}
          aria-valuemax={100}
          aria-valuemin={0}
        />
      </div>
      <div>
        <span>{Numbers.shortenNumber(totalStars)}</span>
      </div>
    </div>
  );
};

type StarReviewGraphProps = {
  averageRating: number;
  totalReviewCount: number;
  ratingDistribution: Record<string, number>;
  productId: number;
};

const StarReviewGraph = ({
  totalReviewCount,
  ratingDistribution,
  productId,
}: StarReviewGraphProps) => {
  const orderedRatingDist = Object.keys(ratingDistribution).reverse();

  return (
    <div className={classNames(styles.container)} data-testid="review-graph">
      <div className={styles.graphContainer}>
        {orderedRatingDist.map((r, i) => (
          <RatingRow
            productId={productId}
            key={i}
            rDistributionNumber={parseInt(r)}
            totalReviews={totalReviewCount}
            totalStars={ratingDistribution[r]}
          />
        ))}
      </div>
    </div>
  );
};

export default StarReviewGraph;
